import React from "react";
import { Select } from "antd";
import useAcademicTerms from "../hooks/useAcademicTerms";

export default function TermSelect({ defaultValue, value, onChange, width }) {
  const termOptions = useAcademicTerms();

  return (
    <Select
      showSearch
      defaultValue={defaultValue}
      value={value}
      options={termOptions}
      onChange={onChange}
      style={{ width: `${width}` }}
    />
  );
}
